import { actionCreatorFactory } from 'typescript-fsa';
import { PickerValidDate } from '@mui/x-date-pickers-pro';
import { IGridDataHandlers } from '@cbridge-utils/datagrid';
import { IApiErrorParams } from '@cbridge-packages/api';
import { ITriggeredAlert } from '@cbridge-packages/alert';
import { IAlertsDashboardFilter, ITriggeredAlertsKey } from './alertsDashboard.interface';

export namespace AlertsDashboardAction {
  const actionCreator = actionCreatorFactory('AlertsDashboard');

  export const updateFilter = actionCreator<IAlertsDashboardFilter>('UPDATE_FILTER');
  export const updateFrom = actionCreator<PickerValidDate>('UPDATE_FROM');
  export const updateTo = actionCreator<PickerValidDate>('UPDATE_TO');
  export const getNextPage = actionCreator('GET_NEXT_PAGE');
  /** User toggle (play/pause); persisted. */
  export const togglePolling = actionCreator('TOGGLE_POLLING');
  /** Programmatic switch at page init; not persisted. */
  export const setPollingEnabled = actionCreator<boolean>('SET_POLLING_ENABLED');

  export const loadAlertList = actionCreator.async<ITriggeredAlertsKey & IGridDataHandlers, ITriggeredAlert[], IApiErrorParams>('LOAD_ALERT_LIST');

  export const destroy = actionCreator('DESTROY');
}
